// Third party imports
import { Modal, Typography } from 'antd';
import AntDButton from '../Button';
import en from 'src/messages/en.json';

export const AccessDeniedModal = ({ show, onHide }) => {
  const { Title, Paragraph } = Typography;

  return (
    <Modal
      open={show}
      onCancel={onHide}
      aria-labelledby="contained-modal-title-vcenter"
      maskClosable={false}
      centered
      title={
        <Title level={4} style={{ margin: 0, padding: '1rem 1rem 0' }}>
          {en.Common.Title.accessDenied}
        </Title>
      }
      footer={
        <div style={{ padding: '0 1rem 1rem' }}>
          <AntDButton
            type="primary"
            onClick={onHide}
            htmlType="button"
            statusOnComplete="Home"
          />
        </div>
      }
    >
      <Paragraph style={{ padding: '1rem', margin: 0 }}>
        You are not authorised to perform this action
      </Paragraph>
    </Modal>
  );
};
